"use strict";

jQuery(function() {
  ModuleCallToAction.init();
  ModuleHeaderVideo.init();
  ModuleTiles.init();
  ModuleVideo.init();
  ModuleAccordion.init();
  ModuleIntextAccordion.init();
  ModulePolaroidCarousel.init();
  ModuleMagazineArchives.init();
  ModuleSlider.init();
  ModuleQualityAssurance.init();

  ModuleHelper.checkHash();
});


var ModuleQualityAssurance = {
  init: function() {
    this.setEventHandlers();
  },

  setEventHandlers: function() {
    jQuery('.module-quality-assurance')
      .on('change', 'select[name="type"]', this.handleTypeChange)
      .on('click', 'button[type="submit"]', this.handleSubmit);
  },

  handleTypeChange: function() {
    var type = jQuery(this).val();
    var form = jQuery(this).closest('form');

    if(type != '') {
      form.find('.charge-group').removeClass('disabled').find('input').prop('disabled', false);
    } else {
      form.find('.charge-group').addClass('disabled').find('input').prop('disabled', true);
    }
  },

  handleSubmit: function(e) {
    e.preventDefault();

    var form = jQuery(this).closest('form');
    var module = form.closest('.module');

    var charge = form.find('input[name="charge"]').val();
    charge = jQuery.trim(charge);

    if(charge == '') {
      form.find('.charge-group').addClass('has-error');
      form.addClass('form-error');
    } else {
      form.find('.charge-group').removeClass('has-error');
      form.removeClass('form-error');

      ModuleQualityAssurance.performSearch(module);
    }

    Tracking.trackEvent('button', 'click', 'quality-assurance-submit');
  },

  performSearch: function(module) {
    var uid = module.data('uid');
    var pdfs = window['qaPdfs_'+uid];
    var found = [];

    jQuery.map(pdfs, function(pdf) {
      if(ModuleQualityAssurance.searchForCharge(module, pdf)) {
        found.push(pdf);
      }
    });

    ModuleQualityAssurance.updateResultList(module, found);
  },

  searchForCharge: function(module, pdf) {
    var type = module.find('select[name="type"]').val();
    var charge = module.find('input[name="charge"]').val();
    charge = charge.replace('_', '');
    charge = charge.replace(' ', '');

    var chargeParts = [];
    var letter = charge.match(/[A-Za-z]{1}/);
    if(letter) {
      if(letter.index != 0) chargeParts.push(charge.substr(0, letter.index));
      //chargeParts.push(charge.substr(letter.index, charge.length - letter.index));
      //chargeParts.push(letter[0] + '_' + charge.substr(letter.index+1, charge.length - (letter.index+1)));
    } else {
      chargeParts.push(charge);
    }

    var found = false;
    var name = pdf.name;
    name = name.toLowerCase();
    switch(type) {
      case 'control':
        if(name.match(/controls/)) {
          jQuery.each(chargeParts, function(idx, part) {
            part = part.toLowerCase();
            var partToSearchIn = name.match(/\d{6,}/);
            if(partToSearchIn) {
              partToSearchIn = partToSearchIn[0];

              if(partToSearchIn.indexOf(part) >= 0) {
                found = true;
              }
            }
          });
          if(found) {
            return true;
          }
        }
        break;
      case 'test':
        if(name.match(/test/)) {
          jQuery.each(chargeParts, function(idx, part) {
            part = part.toLowerCase();

            var partToSearchIn = name.match(/\d{6,}/);
            if(partToSearchIn) {
              partToSearchIn = partToSearchIn[0];

              if(partToSearchIn.indexOf(part) >= 0) {
                found = true;
              }
            }

          });
          if(found) {
            return true;
          }
        }
        break;
      default:
        return false;
    }
  },

  updateResultList: function(module, results) {
    module.find('.quality-assurance-search-results').addClass('active');
    module.find('.table.contenttable').show();
    var tableBody = module.find('table.contenttable tbody');
    tableBody.empty();

    jQuery(results).each(function(idx, result) {
      var link = '<a target="_blank" href="/'+result.url+'"><span class="icon icon-download"></span></a>';
      var tableRow = '<tr><td>'+result.charge+'</td><td>'+result.code+'</td><td>'+result.year+ '-' +result.month+'</td><td class="align-center">'+link+'</td></tr>';

      tableBody.append(tableRow);
    });

    module.find('.message-nothing-found').remove();
    if(results.length == 0) {
      var message = '<p class="message-nothing-found">Keine Ergebnisse gefunden.</p>';
      module.find('table.contenttable').hide().after(message);

    } else {
      //tinysort( module.find('table.contenttable tbody tr td:nth-child(1)'));
      module.find('table.contenttable').show();
    }

    jQuery('html, body').animate({
      scrollTop: module.find('.quality-assurance-search-results:first').offset().top - 68
    }, 500);
  }
};

var ModuleMagazineArchives = {
  init: function() {
    this.setEventHandlers();
  },

  setEventHandlers: function() {
    jQuery('.module-magazine-archives .toggle-tile').on('click', this.toggleTile);
    jQuery('body').on('modules.checkHash', this.loadElement);
    jQuery('body').on('click', '.magazines-view', this.trackViewClick);
    jQuery('body').on('click', '.magazines-download', this.trackDownloadClick);
    jQuery('body').on('click', '.magazines-order', this.trackStartOrderClick);
    jQuery('body').on('click', '#magazines-order', this.trackOrderClick);
  },

  trackViewClick: function() {
    var elm = jQuery(this);
    var module = elm.closest('.module-magazine-information');
    var headline = module.find('h2:first');
    var area = jQuery('body').hasClass('professionals') ? 'professionals' : 'patients';

    Tracking.trackEvent('magazine-view', 'click', area + ': ' + headline.text())
  },


  trackDownloadClick: function() {
    var elm = jQuery(this);
    var module = elm.closest('.module-magazine-information');
    var headline = module.find('h2:first');

    Tracking.trackEvent('magazine-download', 'click', headline.text())
  },

  trackStartOrderClick: function() {
    var elm = jQuery(this);
    var module = elm.closest('.module-magazine-information');
    var headline = module.find('h2:first');
    Tracking.trackEvent('magazine-order', 'start', headline.text())
  },

  trackOrderClick: function() {
    if (-1 == document.getElementById("magazines-order").className.indexOf("disabled")) {
      Tracking.trackEvent('magazine-order', 'submit', '')
    }
  },

  triggerElementWithIdx: function(module, idx) {
    module.find('.toggle-tile').eq(idx).trigger('click');
    ModuleHelper.scrollToContent(module.data('uid'));
  },

  toggleTile: function(e) {
    e.preventDefault();
    //ModuleTiles.currentModule = jQuery(this).closest('.module');
    

    var module = jQuery(this).closest('.module');
    var tile = jQuery(this).parent('.tile')
    var label =  module.data('tl') != '' ?  module.data('tl') : 'uid:' + module.data('uid');
    
    Tracking.trackEvent('tile', 'click', label, tile.data('idx'));
    tile.addClass('active');
    var url = tile.data('contenturl');
    ModuleHelper.loadContentbyUrl(url, ModuleMagazineArchives.updateTileContent, module);
  },

  updateTileContent: function(response, module) {
    var container = module.find('.archive-content');
    container.html(response);
    var offset = container.offset();
    var y = offset.top;
    jQuery('html, body').animate({scrollTop:y}, '500');
  },

  loadElement: function() {
    jQuery('.module-magazine-archives').each(function(mIdx, module) {
      module = jQuery(module);
      ModuleHelper.checkUidAndPerformAction(module, function(idx) {
        ModuleMagazineArchives.triggerElementWithIdx(module, idx);
      });
    });
  }
};

var ModuleTiles = {
  init: function() {
    this.setEventHandlers();
  },

  setEventHandlers: function() {
    jQuery('.module-tiles .toggle-tile').on('click', this.toggleTile);
    jQuery('.module-tiles .btn-close').on('click', this.closeTileContent);
    jQuery('.module-tiles button.next').on('click', this.nextContent);
    jQuery('.module-tiles button.prev').on('click', this.prevContent);

    jQuery('body').on('modules.checkHash', this.loadElement);
  },

  loadElement: function() {
    jQuery('.module-tiles').each(function(idx, module) {
      module = jQuery(module);
      ModuleHelper.checkUidAndPerformAction(module, function(idx) {
        ModuleTiles.triggerElementWithIdx(module, idx);
      });
    });
  },

  triggerElementWithIdx: function(module, idx) {
    module.find('.toggle-tile').eq(idx).trigger('click');
    ModuleHelper.scrollToContent(module.data('uid'));
  },

  prevContent: function(e) {
    e.preventDefault();
    var module = jQuery(this).closest('.module');
    var prevIdx = ModuleTiles.getPrevIndex(module);

    ModuleTiles.loadContentByIdx(module, prevIdx);
  },

  nextContent: function(e) {
    e.preventDefault();
    var module = jQuery(this).closest('.module');

    var nextIdx = ModuleTiles.getNextIndex(module);
    ModuleTiles.loadContentByIdx(module, nextIdx);
  },

  loadContentByIdx: function(module, idx) {
    ModuleTiles.resetActiveState(module);
    var tile = module.find('.tile').eq(idx);
    tile.addClass('active');
    var url = tile.data('contenturl');
    module.addClass('loading');
    ModuleHelper.loadContentbyUrl(url, ModuleTiles.updateTileContent, module);
  },

  getCurrentIndex: function(module) {
    var tiles = module.find('.tile');
    var currentTile = module.find('.tile.active');

    return tiles.index(currentTile);
  },

  getNextIndex: function(module) {
    var currentIdx = ModuleTiles.getCurrentIndex(module);
    var tiles = module.find('.tile');
    if (currentIdx + 1 < tiles.length) {
      return currentIdx + 1;
    }

    return currentIdx;
  },

  getPrevIndex: function(module) {
    var currentIdx = ModuleTiles.getCurrentIndex(module);
    if (currentIdx - 1 >= 0) {
      return currentIdx - 1;
    }

    return currentIdx;
  },

  checkPageNav: function(module) {
    var currentIdx = ModuleTiles.getCurrentIndex(module);

    if (currentIdx == ModuleTiles.getNextIndex(module)) {
      module.find('button.next').addClass('inactive');
    } else {
      module.find('button.next').removeClass('inactive');
    }

    if (currentIdx == ModuleTiles.getPrevIndex(module)) {
      module.find('button.prev').addClass('inactive');
    } else {
      module.find('button.prev').removeClass('inactive');
    }
  },

  toggleTile: function(e) {
    e.preventDefault();
    //ModuleTiles.currentModule = jQuery(this).closest('.module');

    var module = jQuery(this).closest('.module');
    var tile = jQuery(this).parent('.tile');
    var label =  module.data('tl') != '' ?  module.data('tl') : 'uid:' + module.data('uid');

    Tracking.trackEvent('tile', 'click', label, tile.data('idx'));
    tile.addClass('active');
    module.find('.tiles-wrap').slideFadeToggle('slow', function() {
      // Animation complete.
      module.addClass('loading');
      var url = tile.data('contenturl');
      ModuleHelper.loadContentbyUrl(url, ModuleTiles.updateTileContent, module);
    });
  },

  closeTileContent: function(e) {
    e.preventDefault();
    var module = jQuery(this).closest('.module');
    module.find('.tile').removeClass('active');
    module.find('.tile-text').slideFadeToggle('slow', function() {
      // Animation complete.
      module.find('.tiles-wrap').slideFadeToggle('slow', function() {
        // Animation complete.
      });
    });
  },

  updateTileContent: function(response, module) {
    var container = module.find('.tile-text .text');
    container.html(response);

    ModuleTiles.updatePrintLink(module);
    ModuleTiles.updatePdfLink(module);

    if (module.find('.tile-text').is(':visible')) {
      
    } else {
      module.find('.tile-text').slideFadeToggle('slow', function() {
        // Animation complete.
      });
    }

    module.removeClass('loading');
    ModuleTiles.checkPageNav(module);
    jQuery('html, body').animate({
      scrollTop: module.offset().top - 68
    }, 500);
  },

  updatePrintLink: function(module) {
    var tile = module.find('.tile.active');
    var printUrl = tile.data('printurl');
    module.find('.tile-text .icon-printer').data('uri', printUrl);
  },

  updatePdfLink: function(module) {
    var tile = module.find('.tile.active');
    var pdfUrl = tile.data('pdfurl');
    module.find('.tile-text .icon-pdf').data('uri', pdfUrl);
  },

  resetActiveState: function(module) {
    module.find('.tile').removeClass('active');
  }
};

var ModulePolaroidCarousel = {
  init: function() {
    this.initCarousels();
  },

  initCarousels: function() {
    var focus = 1;
    jQuery.each(jQuery('.module-polaroid-carousel'), function(idx, module) {
      module = jQuery(module);
      module.slider = new Bee3D('#'+module.attr('id')+' .slides', {
        wrapper: document.getElementById(module.find('.polaroid-carousel:first').attr('id')),
        effect: 'arc',
        focus: focus,
        infinite: true,
        onInit: function() {
          module.slide = module.find('.slide').eq(focus);
          ModulePolaroidCarousel.updateLinkAndTitle(module.slide);
        }
      });

      module.slider.el.on('activate', function(event){
        module.slide = event.slide;
        ModulePolaroidCarousel.updateLinkAndTitle(jQuery(module.slide));
      });
    });
  },

  updateLinkAndTitle: function(slide) {
    var module = slide.closest('.module');
    var title = jQuery(slide).data('title');
    var link = jQuery(slide).data('link');
    var linktext = jQuery(slide).data('linktext');

    module.find('.special-link').attr('href', link).text(linktext);
    module.find('h3').text(title);
  }
};

var ModuleIntextAccordion = {
  init: function() {

  },
  openAll: function(module) {
    jQuery.each(module.find('.panel-collapse'), function(idx, elm) {
      jQuery(elm).collapse('show');
    })
  }
};

var ModuleAccordion = {
  init: function() {
    this.fetchAllContentsOfModule(jQuery('.module-accordion'));
    this.setEventHandlers();
  },

  setEventHandlers: function() {
    //jQuery('.module-accordion ').on('show.bs.collapse', this.showContent);
    jQuery('body').on('modules.checkHash', this.loadElement);
    jQuery(document).on('shown.bs.collapse', function(event){
      var yOffset = jQuery('.navbar').height();
      var element = jQuery(event.target).closest('.panel');
      var y = element.offset().top - yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    });
  },

  loadElement: function() {
    jQuery('.module-accordion').each(function(idx, module) {
      module = jQuery(module);
      ModuleHelper.checkUidAndPerformAction(module, function(idx) {
        ModuleAccordion.triggerElementWithIdx(module, idx);
      });
    });
  },

  triggerElementWithIdx: function(module, idx) {
    module.find('.panel-collapse').eq(idx).collapse('show');
    ModuleHelper.scrollToContent(module.data('uid'));
  },

  showContent: function(e) {
    var target = e.target;
    var elm = target.closest('.panel');
    var url = jQuery(elm).data('contenturl');

    ModuleHelper.loadContentbyUrl(url, ModuleAccordion.updateContent, jQuery(elm));
  },

  updateContent: function(html, elm) {
    elm.find('.panel-body').html(html);
  },

  fetchAllContentsOfModule: function(module) {
    jQuery(module).find('.panel').each(function(idx, elm) {
      var url = jQuery(elm).data('contenturl');
      ModuleHelper.loadContentbyUrl(url, ModuleAccordion.updateContent, jQuery(elm));
    });
  },

  openAll: function(module) {
    jQuery.each(module.find('.panel-collapse'), function(idx, elm) {
      jQuery(elm).collapse('show');
    })
  }
};

var ModuleVideo = {
  init: function() {
    this.setEventHandlers();
  },

  setEventHandlers: function() {
    jQuery('.module-video .lightbox-video').magnificPopup({
      type: 'iframe',
      iframe: {
        markup: '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
        '</div>',

        patterns: {
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          }
        },

        srcAction: 'iframe_src' // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
      }
    });
        jQuery('.module-video .lightbox-video').on('click', function(e) {
          var module = jQuery(this).closest('.module-video');
      var label = typeof module.data('tl') != 'undefined' && module.data('tl') != '' ? module.data('tl') : 'uid:' + module.data('uid');
      if(!label) {
        label = 'video';
      }
      Tracking.trackEvent('video', 'play', label);

    });
  }
};

var ModuleCallToAction = {
  init: function() {
    this.setEventHandlers();
  },

  setEventHandlers: function() {
    // jQuery('.module-call-to-action .flip-container').on('touchstart touchend', this.handleTouch);
    jQuery('.module-call-to-action .flip-container').on('click', this.trackClick);
  },

  handleTouch: function(e) {
    e.preventDefault();
    var elm = jQuery(this);
    var doFlip = true;

    elm.closest('.module').find('.flip-container').not(this).removeClass('hover');

    if(elm.find('a').length) {
      doFlip = false;
    }
    if (!doFlip || elm.hasClass('hover')) {

    } else {
      e.preventDefault();
      elm.addClass('hover');
    }
  },

  trackClick: function() {
    var elm = jQuery(this);
    var module = elm.closest('.module');

    var label = module.data('tl') != '' ? module.data('tl') : 'uid:'+module.data('uid');

    Tracking.trackEvent('CTA', 'click', label, elm.data('idx'));
  }
};

var ModuleHeaderVideo = {
  init: function() {
    this.setEventHandlers();
  },

  setEventHandlers: function() {
    jQuery(document.body).on('click', '.module-header-video-image .play-video-btn', this.triggerVideo);

    if (window.addEventListener) {
      window.addEventListener('message', this.onMessageReceived);
    }
    else {
      window.attachEvent('onmessage', this.onMessageReceived);
    }
  },

  onMessageReceived: function(event) {
    // handle messages from the vimeo player only
    if (!(/^https?:\/\/player.vimeo.com/).test(event.origin)) {
      return false;
    }

    var data = JSON.stringify(event.data);

    if (!data.player_id) return;
    // handle only events for players of this module
    if (!data.player_id.match(/^hv_vimeoplayer_/)) return;

    switch (data.event) {
      case 'ready':
        // ModuleHeaderVideo.onReady(data.player_id);
        break;

      case 'play':
        ModuleHeaderVideo.onPlay(data.player_id);
        break;

      case 'pause':
        ModuleHeaderVideo.onPause(data.player_id);
        break;

      case 'finish':
        ModuleHeaderVideo.onFinish(data.player_id);
        break;
    }
  },

  onReady: function(playerId) {
    var iframe = jQuery('#' + playerId);
    ModuleHeaderVideo.post(iframe, 'addEventListener', 'pause');
    ModuleHeaderVideo.post(iframe, 'addEventListener', 'finish');
    ModuleHeaderVideo.post(iframe, 'addEventListener', 'play');

  },

  onPlay: function(playerId) {
    var iframe = jQuery('#' + playerId);
    iframe.prev('.play-video').hide();
  },

  onPause: function(playerId) {
    var iframe = jQuery('#' + playerId);
    iframe.prev('.play-video').show();
  },

  onFinish: function(playerId) {
    var iframe = jQuery('#' + playerId);
    iframe.prev('.play-video').show();
  },

  triggerVideo: function(e) {

    e.preventDefault();
    e.stopPropagation();
    var iframe = jQuery(this).closest('.video-wrap').find('iframe');
    var module = jQuery(this).closest('.module');
        iframe.attr('src', iframe.attr('rel'));
    window.setTimeout(function(){iframe.css('opacity','1');iframe.prev().hide();},500);
    ModuleHeaderVideo.post(iframe, 'play');

    // Hide Video Container
    var videoContainer = jQuery(this).closest('.play-video');
    videoContainer.hide();

    var label = typeof module.data('tl') != 'undefined' && module.data('tl') != '' ? module.data('tl') : 'uid:' + module.data('uid');
    if(!label) {
      label = 'video';
    }
    Tracking.trackEvent('video', 'play', label);
  },

  // Helper function for sending a message to the player
  post: function(player, action, value) {
    var data = {
      method: action
    };

    if (value) {
      data.value = value;
    }

    //var message = JSON.stringify(data);
    player[0].contentWindow.postMessage(data, '*');
  }
};

var ModuleSlider = {
  init: function () {
    this.setUpSlider();
  },

  setUpSlider: function() {
    jQuery('.slick-slider').slick({
      autoplay: true,
      autoplaySpeed: 7000,
      pauseOnHover: false,
      dots: true,
      speed: 500,
      fade: true,
      cssEase: 'ease-out',
      prevArrow: '<button type="button" class="controls prev icon-arrow-r-w">' +
      '<span class="sr-only">zurück</span>' +
      '</button>',
      nextArrow: '<button type="button" class="controls next icon-arrow-r-w">' +
      '<span class="sr-only">weiter</span>' +
      '</button>'
    });
  }

};

var ModuleHelper = {

  getHash: function() {
    var hash = document.location.hash;
    hash = hash.replace('#', '');

    return hash;
  },

  checkHash: function() {
    var hash = this.getHash();

    if (hash) {
      jQuery('body').trigger('modules.checkHash');
    }
  },

  extractUidFromHash: function() {
    var hash = this.getHash();
    var matches = hash.match(/^(\d+)-(\d+)$/);

    if (matches) {
      return matches[1];
    }
  },

  extractIndexFromHash: function() {
    var hash = this.getHash();
    var matches = hash.match(/^(\d+)-(\d+)$/);

    if (matches) {
      return matches[2];
    }
  },

  checkUidAndPerformAction: function(module, callback) {
    if (module.data('uid') != this.extractUidFromHash()) return;

    var idx = this.extractIndexFromHash();
    callback(idx);
  },

  loadContentbyUrl: function(url, callback, data) {
    jQuery.ajax({
      url: url,
      type: 'get',
      dataType: 'html',
      success: function(response) {
        callback(response, data);
      }
    });
  },

  scrollToContent: function(uid) {
    var elm = jQuery('.module[data-uid="' + uid + '"]');
    if (elm.length != 0) {
      var offset = elm.offset();
      var y = offset.top;
      jQuery('html, body').scrollTop(y);
    }
  }
};


